import { render, staticRenderFns } from "./PauseIcon.vue?vue&type=template&id=b1128f72&"
import script from "./PauseIcon.vue?vue&type=script&lang=js&"
export * from "./PauseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports